import React from 'react'
import ReactTable from 'react-table-6'
import moment from 'moment'
import { I18n } from 'react-redux-i18n'

// import { currencySymbol } from '../lib/currency-formatter';
import { PricesExtended } from '@bdswiss/mt4-connector'
import { BondTrade, CouponInfo } from '../types'
import BondPositionEdit from './BondPositionEdit'
import './PositionsTable.css'
import Spinner from './Spinner'
import { currencySymbol } from '../lib/currency-formatter'

export interface Props {
  accountLoaded: boolean
  assets: PricesExtended
  bondsPositions: BondTrade[]
  currency: string
  locale: string
  onCloseTrade: (order: number, uuid?: string) => void
  tradeOperationEnabled: boolean
}

export interface State {
  filter: string
}

class BondPositionsTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { filter: 'active' }
  }

  public render() {
    if (!this.props.assets || !this.props.accountLoaded) {
      // console.log('Positions pane loading...');
      return <Spinner />
    }
    const {
      // assets,
      bondsPositions,
      currency,
      locale,
      onCloseTrade,
      tradeOperationEnabled,
    } = this.props

    const columns = [
      {
        expander: true,
        headerStyle: { display: 'none' },
        width: 30,
      },
      {
        // Header: 'Time',
        headerStyle: { display: 'none' },
        accessor: 'openTime',
        minWidth: 60,
        Cell: (props: any) => {
          const { trade } = props.original
          moment.locale(this.props.locale)
          const dateTime = moment(trade.openTime)
          return (
            <div>
              <div className="bdswiss-table--bold">{dateTime.format('MMM DD')}</div>
              <div>{dateTime.format('YYYY')}</div>
            </div>
          )
        },
      },
      {
        headerStyle: { display: 'none' },
        accessor: 'company',
        minWidth: 100,
        Cell: (props: any) => {
          moment.locale(locale)
          const { trade, bond, coupons } = props.original
          const paidInterest = coupons.reduce(
            (acc: number, coupon: CouponInfo) => (acc += coupon.amount),
            0
          )
          const accruedInterest = (bond.accruedInterest / bond.faceValue) * trade.volume
          return (
            <div>
              <div className="bdswiss-table--bold">{bond.name}</div>
              <div className="bdswiss-table--positive">
                {currencySymbol(currency)}
                {(paidInterest + accruedInterest).toFixed(2)}
              </div>
            </div>
          )
        },
      },
      {
        headerStyle: { display: 'none' },
        accessor: 'principal',
        minWidth: 60,
        Cell: (props: any) => {
          moment.locale(locale)
          const { trade, bond } = props.original
          return (
            <div>
              <div className="bdswiss-table--bold bdswiss-table--right">
                {currencySymbol(bond.currency)}
                {trade.volume.toFixed(2)}
              </div>
              <div className="bdswiss-table--right">{bond.couponInterestRate}%</div>
            </div>
          )
        },
      },
    ]

    return (
      <ReactTable
        noDataText={I18n.t('noOpenPositions')}
        data={bondsPositions}
        columns={columns}
        className="bdswiss-table"
        showPagination={false}
        sortable={false}
        defaultSorted={[
          {
            id: 'openTime',
            desc: true,
          },
        ]}
        // freezeWhenExpanded={true}
        collapseOnDataChange={false}
        minRows={15}
        pageSize={110}
        getTrProps={(state: any, rowInfo: any, col: any, instance: any) => {
          return {
            onClick: () => {
              const { expanded } = state
              const path = rowInfo.nestingPath[0]
              const diff = { [path]: expanded[path] ? false : true }

              instance.setState({
                expanded: {
                  ...expanded,
                  ...diff,
                },
              })
            },
          }
        }}
        SubComponent={row => {
          const { trade } = row.original
          return (
            <BondPositionEdit
              position={row.original}
              currency={currency}
              locale={locale}
              onClose={onCloseTrade.bind(null, trade.order, trade.uuid)}
              accountLoaded={this.props.accountLoaded}
              tradeOperationEnabled={tradeOperationEnabled}
            />
          )
        }}
      />
    )
  }
}

export default BondPositionsTable
